import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * RiskRecordActionPathDisassociation
 *
 * Disassociates EID's from Action Paths and vice versa.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const RiskRecordActionPathDisassociation = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: thePayload,
      headers: {
        'x-api-endpoint': '/risk-records/manual/disassociate',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/mutations/RiskRecordActionPathDisassociation.js -> RiskRecordActionPathDisassociation()',
      false,
      error
    );

    throw error;
  }
};
